import React, { FC, useState, useMemo } from 'react';
import moment from 'moment';
import { Dialog, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { SubCashbackCommissionReport, CashbackTransactionStatus } from '../../IBClientsCashbackModel';
import { dateObjectToMonthYearString, getTranslation } from '../../../../../utils';
import { ExportCSV } from '../ReportTitle/ExportCSV';
import { DetailedTable } from './DetailedTable';
import { useStyles } from './styles';

interface Props {
  campaignName: string;
  translation: any;
  dateFrom: Date;
  title: any;
  data: SubCashbackCommissionReport[];
  open: boolean;
  handleCancel: () => void;
}

export const DetailedDialog: FC<Props> = ({ title, campaignName, dateFrom, data, open, handleCancel, translation }) => {
  const classes = useStyles();
  const columnNames = useMemo(
    () => [
      translation.client_trading_account,
      translation.calculation_date,
      translation.calculation_period,
      translation.campaign_name,
      translation.volume_usd,
      translation.volume_lots,
      translation.commission_usd,
      translation.cashback_usd,
      translation.cashback_status,
    ],
    [translation],
  );
  const [selectedColumns, setSelectedColumns] = useState<string[]>(columnNames);

  const exportReportName = (): string => {
    let reportName = translation.text_6035;
    const dateString = dateObjectToMonthYearString(dateFrom);
    reportName += dateString ? ` ${getTranslation(translation, moment(dateString).format('MMMM'))} ${moment(dateString).format('YYYY')}` : '';

    return reportName;
  };

  const renderTableData = (): string[][] => {
    const rows: string[][] = [];
    data.forEach((row) => {
      const tableRow: string[] = [
        row.login ? row.login.toString() : '-',
        row.calculationDate || row.calculationDate === '' ? moment(row.calculationDate).format('DD-MM-YYYY') : '-',
        (row.periodStart || row.periodStart === '') && (row.periodEnd || row.periodEnd === '') ? `${moment(row.periodStart).format('DD-MM-YYYY')} - ${moment(row.periodEnd).format('DD-MM-YYYY')}` : '-',
        campaignName || '-',
        row.volumeUsd || row.volumeUsd === 0 ? row.volumeUsd.toFixed(2) : '-',
        row.volumeLots || row.volumeLots === 0 ? row.volumeLots.toFixed(2) : '-',
        row.commission || row.commission === 0 ? row.volumeUsd.toFixed(2) : '-',
        row.cashbackAmount || row.cashbackAmount === 0 ? row.cashbackAmount.toFixed(2) : '-',
        CashbackTransactionStatus[row.transactionStatus],
      ];
      rows.push(tableRow);
    });

    return rows;
  };

  return (
    <Dialog onClose={handleCancel} open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Grid container justify="space-between" spacing={1} alignItems="center">
          <Grid item style={{ marginRight: 30 }}>
            <Typography variant="h6">{title}</Typography>
          </Grid>
          <Grid item>
            <Grid container justify="flex-end">
              <ExportCSV exportFileName={exportReportName()} columns={columnNames} exportTableData={renderTableData()} isEnabled reportNameInEn="Detailed IB Cashback Report" />
              <IconButton className={classes.closeBtn} onClick={handleCancel}>
                <Close />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>
      <Grid container direction="column" className={classes.root}>
        <DetailedTable translation={translation} campaignName={campaignName} columnNames={columnNames} selectedColumns={selectedColumns} rows={data} onSelectColumns={(columns) => setSelectedColumns(columns)} />
      </Grid>
    </Dialog>
  );
};
